module.exports = __webpack_public_path__ + "static/media/post-video.48b513b6.svg";